<template>
  <div class="reviewPostButtonsArea pc">
    <div class="button buttonReviewPost" @click="showModal(); showBox()"><span>投稿する</span></div>
  </div>
  <div class="reviewPostButtonsArea sp">
    <div class="button buttonReviewMenu" @click="showModal()"><span></span></div>
  </div>
  <div class="form" v-if="show">
    <div class="reviewPostButtonsArea sp" v-if="!show_box">
      <div class="button buttonReviewMenu close" @click="closeModal(); closeBox()"><span></span></div>
      <div class="button buttonReviewPost" @click="showBox()"><span>投稿</span></div>
    </div>
    <div class="box" v-if="show_box">
      <div class="header">
        <h2>レビュー投稿</h2>
        <div class="close" @click="closeModal(); closeBox()"></div>
      </div>
      <div ref="slider" class="contents keen-slider">
        <div class="reserveForms">
          <div class="inputs">
            <h3>店舗名</h3>
            <p>{{ shop.name }}</p>
            <h3>評価</h3>
            <review-rating @input="setReview" :ratingClass="{ error: errors.review }"></review-rating>
            <p v-for="error in errors.review" class="formError">
              {{ error }}
            </p>
            <h3>タイトル</h3>
            <input
              type="text"
              v-model="params.title"
              placeholder="タイトルを入力してください（255文字以下）"
              :class="{ error: errors.title }"
            />
            <p v-for="error in errors.title" class="formError">
              {{ error }}
            </p>
            <h3>コメント</h3>
            <textarea
              v-model="params.content"
              cols="30"
              rows="10"
              placeholder="口コミ本文を入力してください（5,000文字以下）"
              :class="{ error: errors.content }"
            ></textarea>
            <p v-for="error in errors.content" class="formError">
              {{ error }}
            </p>
            <h3>写真の追加</h3>
            <p>※ 拡張子はpng, jpeg, gifの対応となります。<br>
※ 画像は1MB未満でアップロードをお願いいたします。<br>
※ 画像は最大5枚までアップロード可能です。</p>
            <file-upload @input="setFiles" :fileLimit="5"></file-upload>
            <p v-for="error in errors.files" class="formError">
              {{ error }}
            </p>
          </div>
          <div class="next">
            <p class="terms">
              <a href="/privacy_policy" target="_blank" rel="noopener">プライバシーポリシー</a>及び<a href="/tos" target="_blank" rel="noopener">利用規約</a>
            </p>
            <div class="button agreeButton" :class="{ disabled: isDisabledButton }" @click="submit">同意して投稿する</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showComplete">
    <post-complete :showComplete="showComplete" @input="showComplete = $event"></post-complete>
  </div>
</template>
<script>
export default {
  props: {
    shop: Object,
  },
  data() {
    return {
      show: false,
      show_box: false,
      showComplete: false,
      isDisabledButton: false,
      params: {
        shop_id: '',
        title: '',
        content: '',
        review: 0,
        files: []
      },
      errors: {}
    };
  },
  mounted() {
    this.params.shop_id = this.shop.id;
  },
  methods: {
    showModal() {
      this.show = true;
    },
    closeModal() {
      this.show = false;
    },
    showBox() {
      this.show_box = true;
    },
    closeBox() {
      this.show_box = false;
    },
    checkValidation() {
      // 必須チェック
      this.errors = {};

      // タイトル
      if (this.params.title.length === 0) {
        this.errors.title = ["タイトルは必ず入力してください"];
      }
      if (this.params.title.length > 255) {
        this.errors.title = ["タイトルは255文字以下で入力してください"];
      }

      // コメント
      if (this.params.content.length === 0) {
        this.errors.content = ["コメントは必須入力です"];
      }
      if (this.params.content.length > 5000) {
        this.errors.content = ["コメントは5000文字以下で入力してください"];
      }

      // 評価
      if (this.params.review < 1 || this.params.review > 5) {
        this.errors.review = [];
      }
      if (this.params.review < 1) {
        this.errors.review.push("評価は1〜5で指定してください");
      }
      if (this.params.review > 5) {
        this.errors.review.push("評価は1〜5で指定してください");
      }

      return Object.keys(this.errors).length === 0;
    },
    setReview(value) {
      this.params.review = value;
    },
    setFiles(files) {
      this.params.files = files;
    },
    submit() {
      // 多重submit防止
      this.isDisabledButton = true

      if (this.checkValidation()) {
        const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        };
        let data = new FormData();
        data.append('shop_id', this.params.shop_id);
        data.append('review', this.params.review);
        data.append('title', this.params.title);
        data.append('content', this.params.content);
        for (const i in this.params.files) {
          data.append('files['+i+']', this.params.files[i]);
        }
        this.$axios.post('/api/users/review/add', data, config)
            .then(() => {
              this.params.title = '';
              this.params.content = '';
              this.closeModal();
              this.closeBox();
              this.showComplete = true
              this.isDisabledButton = false
            }).catch(e => {
              this.isDisabledButton = false
              if (!this.$_.isEmpty(e.response.data.errors.review)) {
                this.errors.review = e.response.data.errors.review;
              }
              if (!this.$_.isEmpty(e.response.data.errors.title)) {
                this.errors.title = e.response.data.errors.title;
              }
              if (!this.$_.isEmpty(e.response.data.errors.content)) {
                this.errors.content = e.response.data.errors.content;
              }
              this.errors.files = [];
              if (!this.$_.isEmpty(e.response.data.errors['files.0'])) {
                this.errors.files = e.response.data.errors['files.0'];
              }
              if (!this.$_.isEmpty(e.response.data.errors['files.1'])) {
                this.errors.files = e.response.data.errors['files.1'];
              }
              if (!this.$_.isEmpty(e.response.data.errors['files.2'])) {
                this.errors.files = e.response.data.errors['files.2'];
              }
              if (!this.$_.isEmpty(e.response.data.errors['files.3'])) {
                this.errors.files = e.response.data.errors['files.3'];
              }
              if (!this.$_.isEmpty(e.response.data.errors['files.4'])) {
                this.errors.files = e.response.data.errors['files.4'];
              }
          })
      } else {
        this.isDisabledButton = false
      }
    }
  },
  watch: {
    show(val) {
      if (!val) return;
    },
  },
};
</script>

<style lang="scss" scoped>
input.error, textarea.error {
  border: 2px solid #c63200;
  margin-bottom: 2rem !important;
  + p {
    margin-bottom: 2rem !important;
  }
}
.formError {
  font-size: 1.2rem !important;
  color: #c63200 !important;
  line-height: 1 !important;
  margin-bottom: 1.6rem !important;
}
</style>
